import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';
import { formatCurrntDateTime, getValueFromResource, setItemStatus } from '../../../common/timeLiveFunction';
import clsx from 'clsx';
import { GetAccountEmployeeReportScheduleEmailLog } from './CustomReportViewSlice';
import { useLocation } from 'react-router-dom';

const ScheduleReportAudit = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { cultureInfoName } = useAppSelector((state) => state.globalState);
    const [auditLogs, setAuditLogs] = useState<any[]>([]);
    const location = useLocation();
    const {AccountEmployeeReportScheduleId} = location?.state || 0;
    
    useEffect(() => {
        const getScheduleReportAuditLogs = async () => {
            try {
                const response = await dispatch(GetAccountEmployeeReportScheduleEmailLog(AccountEmployeeReportScheduleId));
                const json = response?.payload;
                if (json?.StatusCode === '200') {
                    setAuditLogs(json?.Data);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getScheduleReportAuditLogs();
    }, [])

    return (
        <div className="card card-custom admin-card">
            <div className="card-header  card-drop-dr sticky-top bg-white">
                <h3 className="card-title fw-bold headerTitle">
                    {getValueFromResource('Scheduled Report Log', dispatch, t)}
                </h3>
            </div>
            <div className="table-responsive" style={{ marginTop: 8 }}>
                <table className="table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1" style={{ width: '100%' }}>
                    <thead>
                        <tr className="thHeading align-middle">
                            <th style={{ width: '20%' }}>
                                {getValueFromResource('Schedule Name', dispatch, t)}
                            </th>
                            <th style={{ width: '10%' }}>
                                {getValueFromResource('File Type', dispatch, t)}
                            </th>
                            <th style={{ width: '30%' }}>
                                {getValueFromResource('Message', dispatch, t)}
                            </th>
                            <th style={{ width: '20%' }}>
                                {getValueFromResource('Email Sent Date', dispatch, t)}
                            </th>
                            <th style={{ width: '10%' }}>
                                {getValueFromResource('Status', dispatch, t)}
                            </th>
                            {/* <th style={{ width: '10%' }}>
                            </th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {auditLogs?.map((item, index) => (
                            <tr key={index} style={{ height: '50px' }}>
                                <td>{item?.ScheduleName}</td>
                                <td>{item?.SystemReportFileType}</td>
                                <td>{item.EmailSentMessage}</td>
                                <td>{`${formatCurrntDateTime(item?.EmailSentDate, cultureInfoName?.toString())}`}</td>
                                <td>
                                    <span className={clsx('expenseStatus-td app-navbar-item badge ', setItemStatus(item?.IsSuccess ? 'Success' : 'Fail'))}>
                                        {item?.IsSuccess ? 'Success' : 'Fail'}
                                    </span>
                                </td>
                                {/* <td></td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>
                {auditLogs?.length === 0 &&
                    <div className='mt-4'>
                        <p className='noDataFound'>
                            {getValueFromResource('No Record Found', dispatch, t)}
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}

export default ScheduleReportAudit